<script lang="ts">
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct";
  import BundledProductListItem from "./BundledProductListItem.svelte";

  export let bundledProducts: RecommendedProduct[]
</script>

<div>
  <ul class="bundled-product-list">
    {#each bundledProducts as product}
      <li style="height: calc(100% / {bundledProducts.length})">
        <BundledProductListItem 
          {product}
        />
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  div {
    padding-top: 100%;
    position: relative;
  }
  
  ul {
    position: absolute;
    top: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }
</style>